import React, { useState, useEffect } from 'react'
import PT from 'prop-types'
import { FaTimesCircle } from 'react-icons/fa'
// import { window } from 'browser-monads'

import { TypeRichTextField } from '../../../utils/types'
import RichTextField from '../../atoms/RichTextField/RichTextField'

import { Wrapper, DismissBtn, Container, ContentSection } from './styled'

const isBrowser = typeof window !== `undefined`

const Ribbon = ({
  isBlue,
  content,
  isInverse,
  isSticky,
  children,
  handleOnClick,
}) => {
  const urlToIgnore = 'covid-19'

  // TODO: Remove hack after Covid-19
  let isNonCovidPage

  if (isBrowser) {
    if (window.location.pathname.includes(urlToIgnore)) {
      isNonCovidPage = false
    } else {
      isNonCovidPage = true
    }
  }

  // TODO: Remove hack after covid-19
  const isCovidPage = isNonCovidPage
  const [isPresent, setIsPresent] = useState(isCovidPage || true)
  // TODO: Remove this hack once we've migrated the site
  // const navEl = document.getElementById('js-global-nav')
  // const navHeight = navEl ? navEl.clientHeight : 80

  // USEEFFECT: Set TImeout
  useEffect(() => {
    const timer = setTimeout(() => {
      if (isBrowser) {
        if (window.location.pathname.includes(urlToIgnore)) {
          setIsPresent(false)
        } else {
          setIsPresent(true)
        }
      }
    }, 0)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Wrapper
      isInverse={isInverse}
      isSticky={isSticky}
      isPresent={isPresent}
      isBlue={isBlue}
    >
      <Container>
        <ContentSection onClick={handleOnClick} role="button">
          {children}
          <RichTextField data={content} />
        </ContentSection>

        <DismissBtn isInverse={isInverse} onClick={() => setIsPresent(false)}>
          <FaTimesCircle />
        </DismissBtn>
      </Container>
    </Wrapper>
  )
}

Ribbon.propTypes = {
  content: TypeRichTextField,
  isInverse: PT.bool,
  isSticky: PT.bool,
  isBlue: PT.bool,
  children: PT.node,
  handleOnClick: PT.func,
}

export default Ribbon



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Ribbon/Ribbon.js